module.exports = __webpack_public_path__ + "static/media/receipt.b28bc92f.png";